import InfoWithTooltip from './InfoWithTooltip';

const CreatedBy = ({
  lessonId,
  name,
  texts,
}: {
  lessonId: number;
  name: string;
  texts: {
    tooltip: (name: string) => string;
  };
}) => {
  return (
    <p
      className="d-flex align-items-center justify-content-start m-0"
      style={{ gap: '8px' }}
    >
      <InfoWithTooltip
        show
        tooltipId={`${lessonId}-tooltip`}
        tooltipText={texts.tooltip(name)}
      />
      Ingresado por: {name}
    </p>
  );
};

export default CreatedBy;
